"use client";
import Link from "next/link";
import React, { useState } from "react";
import { CommunityCreateModal } from "~/components/v3/community-components/CommunityCreateModal";
import { Button, ButtonProps } from "~/components/v4/themed/Button";
import { cn } from "~/utils/fontsConfig";

type Props = {
    variant?: ButtonProps["variant"];
    title?: string;
    size?: ButtonProps["size"];
    className?: React.HTMLAttributes<HTMLButtonElement>["className"];
};

const HomeCreateCommunity = ({
    variant = "primaryLink",
    title,
    size = "default",
    className,
}: Props) => {
    const [isCommunityCreateVisible, setIsCommunityCreateVisible] =
        useState(false);

    return (
        <div className="inline-flex">
            <Button
                size={size}
                variant={variant}
                className={cn(
                    "h-[30px]",
                    variant === "primaryLink" ? "m-0 inline p-0" : "",
                    className,
                )}
            >
                {/* <Link href="/beta/community/create">
                    {title ?? "Launch your own"}
                </Link> */}
            </Button>
            <CommunityCreateModal
                isVisible={isCommunityCreateVisible}
                setVisible={setIsCommunityCreateVisible}
            />
        </div>
    );
};

export default HomeCreateCommunity;
